module.exports = __webpack_public_path__ + "img/xnxlc-main-sm.609cbca5.jpg";